/* ============
 * Mutations for the message module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */
import { getFormattedDate } from '@/utils/date';
import constants from '@/constants/app.properties';
import types from './mutation-types';

const groupByDate = (messages) => {
  const groupedMessages = {};
  messages.map((message) => {
    if (!groupedMessages[
      getFormattedDate(message.created_at, constants.DAY_OF_MONTH_FORMAT)
    ]) {
      groupedMessages[
        getFormattedDate(message.created_at, constants.DAY_OF_MONTH_FORMAT)
      ] = [];
    }
    groupedMessages[
      getFormattedDate(message.created_at, constants.DAY_OF_MONTH_FORMAT)
    ].push(message);
    return null;
  });
  return groupedMessages;
};

const connectToVideoCall = (state) => {
  VC.CreateVidyoConnector({
    viewId: "videoConference",
    viewStyle: "VIDYO_CONNECTORVIEWSTYLE_Default",
    remoteParticipants: 8,
    logFileFilter: "warning info@VidyoClient info@VidyoConnector",
    logFileName: "",
    userData: ""
  }).then(function (vidyoConnector) {
    
    state.videoCallDetails.vidyoConnector = vidyoConnector
    
    //For acessing camera, microphone and speaker in chrome for latest vidyo library 4.1.24.15 register this device listener
    vidyoConnector.RegisterLocalCameraEventListener({
      onAdded: function (localCamera) {
        // New camera is available
      },
      onRemoved: function (localCamera) {
        // Existing camera became unavailable
      },
      onSelected: function (localCamera) {
        // Camera was selected/unselected by you or automatically
      },
      onStateUpdated: function (localCamera, state) {
        // Camera state was updated
      }
    }).then(function () {
      console.log("RegisterLocalCameraEventListener Success");
    }).catch(function () {
      console.error("RegisterLocalCameraEventListener Failed");
    });

    // Handle appearance and disappearance of microphone devices in the system
    vidyoConnector.RegisterLocalMicrophoneEventListener({
      onAdded: function (localMicrophone) {
        // New microphone is available
      },
      onRemoved: function (localMicrophone) {
        // Existing microphone became unavailable
      },
      onSelected: function (localMicrophone) {
        // Microphone was selected/unselected by you or automatically
      },
      onStateUpdated: function (localMicrophone, state) {
        // Microphone state was updated
      }
    }).then(function () {
      console.log("RegisterLocalMicrophoneEventListener Success");
    }).catch(function () {
      console.error("RegisterLocalMicrophoneEventListener Failed");
    });

    // Handle appearance and disappearance of speaker devices in the system
    vidyoConnector.RegisterLocalSpeakerEventListener({
      onAdded: function (localSpeaker) {
        // New speaker is available
      },
      onRemoved: function (localSpeaker) {
        // Existing speaker became unavailable
      },
      onSelected: function (localSpeaker) {
        // Speaker was selected/unselected by you or automatically
      },
      onStateUpdated: function (localSpeaker, state) {
        // Speaker state was updated
      }
    }).then(function () {
      console.log("RegisterLocalSpeakerEventListener Success");
    }).catch(function () {
      console.error("RegisterLocalSpeakerEventListener Failed");
    });

    vidyoConnector.Connect({
      host: "prod.vidyo.io",
      token: state.videoCallDetails.token,
      displayName: state.videoCallDetails.userName, //User Name
      resourceId: state.videoCallDetails.resourceId.toString(), //Conference Name,
      onSuccess: function (reason) {
        console.log("Successfully connected ", reason);
      },
      onFailure: function (reason) {
        console.log("Error while connecting ", reason);
      },
      onDisconnected: function (reason) {
        console.log("Disconnected ", reason);
      }
    }).then(function (status) {

    }).catch(function () {

    });
  });
};

export default {
  [types.FETCH_PATIENTS_LIST](state) {
    state.isPatientListLoading = true;
  },
  [types.FETCH_PATIENTS_LIST_SUCCESS](state, { response, filter }) {
    state.isPatientListLoading = false;
    state.patients = filter.pageNo > 1 ?
      [...state.patientMessages, ...response.PatientMessages] :
      response.PatientMessage;
    state.patientsTotalCount = response.totalCount;
  },
  [types.FETCH_PATIENTS_LIST_FAIL](state, error) {
    state.isPatientListLoading = false;
    state.error = error;
  },

  [types.FETCH_PATIENTS_MESSAGE_LIST](state) {
    state.isPatientMessageListLoading = true;
  },
  [types.FETCH_PATIENTS_MESSAGE_LIST_SUCCESS](state, { filter, response }) {
    state.isPatientMessageListLoading = false;
    const updatedMessages = filter.filter.pageNo > 1 ?
      [...state.patientMessages, ...response.PatientMessages] :
      response.PatientMessages;
    state.patientMessages = updatedMessages;
    const groupedMessages = groupByDate(updatedMessages);
    state.groupedMessages = groupedMessages;
    state.patientMessageKeys = Object.keys(groupedMessages);
    state.patientMessageTotalCount = response.totalCount;
  },
  [types.FETCH_PATIENTS_MESSAGE_LIST_FAIL](state, error) {
    state.isPatientMessageListLoading = false;
    state.error = error;
  },

  [types.SEND_MESSAGE](state) {
    state.isMessageSending = true;
  },
  [types.SEND_MESSAGE_SUCCESS](state, response) {
    state.isMessageSending = false;
    const messages = [...[response], ...state.patientMessages];
    state.patientMessages = messages;
    const groupedMessages = groupByDate(messages);
    state.groupedMessages = groupedMessages;
    state.patientMessageKeys = Object.keys(groupedMessages);
  },
  [types.SEND_MESSAGE_FAIL](state, error) {
    state.isVideoCalling = false;
    state.error = error;
  },
  [types.START_VIDEO_CALL](state) {
    connectToVideoCall(state);
  },
  [types.START_VIDEO_CALL_FAIL](state, error) {
    state.isVideoCalling = false;
    state.error = error;
  }
};
